import styled from "styled-components";

const NavigationGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export default NavigationGroup;